export default __webpack_public_path__ + "static/media/icon-sauce-delivery.8ea7e805.svg";